import { useLocation, useNavigate } from "react-router-dom";

export type UseNavigatorResult = (
  url: string,
  replace?: boolean,
  preserveQs?: boolean,
  scrollToTop?: boolean
) => void;
function useNavigator(): UseNavigatorResult {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    url: string,
    replace = false,
    preserveQs = false,
    scrollToTop = true
  ) => {
    const targetUrl = preserveQs ? url + location.search : url;
    if (replace) {
      navigate(targetUrl, { replace: true });
    } else {
      navigate(targetUrl);
    }

    if (scrollToTop) {
      window.scrollTo({ behavior: "smooth", top: 0 });
    }
  };
}

export default useNavigator;
